import { motion } from "framer-motion";

export const easeOut = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 30, ...rest }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.85, delay, ease: easeOut }}
        {...rest}
    >
        {children}
    </motion.div>
);

/* The whileInView observer sits on the OUTER (unclipped, untransformed) span;
   variants propagate to the inner span so the mask reveal actually fires. */
export const MaskLine = ({ children, delay = 0, className = "" }) => (
    <motion.span
        className="block overflow-hidden pb-[0.08em] -mb-[0.08em]"
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
    >
        <motion.span
            className={"block " + className}
            variants={{ hidden: { y: "115%" }, show: { y: "0%" } }}
            transition={{ duration: 0.9, delay, ease: easeOut }}
        >
            {children}
        </motion.span>
    </motion.span>
);

export const Eyebrow = ({ children, className = "" }) => (
    <p className={"text-[11px] sm:text-xs font-semibold uppercase tracking-[0.3em] text-gold " + className}>
        {children}
    </p>
);